export default {
    companies: [],
    orders: [],
    orderInfo: {
        id: null,
        order: null,
        total_quantity: null,
        products_created: null,
        et_products: []
    },
    quantity: 0,
    filter: {
        company_id: null,
        order: null,
        state: null,
        from: null,
        to: null,
        quantity: null,
        comment: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    loading_data_select: false,
}



